module.exports = "uniform sampler2D u_Texture;\r\nuniform vec2 u_Delta;\r\nvarying vec2 v_Uv;\r\nvoid main() {\r\n\tvec4 info = texture2D(u_Texture, v_Uv);\r\n\tvec3 dx = vec3(u_Delta.x, texture2D(u_Texture, vec2(v_Uv.x + u_Delta.x, v_Uv.y)).r - info.r, 0.0);\r\n\tvec3 dy = vec3(0.0, texture2D(u_Texture, vec2(v_Uv.x, v_Uv.y + u_Delta.y)).r - info.r, u_Delta.y);\r\n\tinfo.ba = normalize(cross(dy, dx)).xz;\r\n\tgl_FragColor = info;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/vertexInfo/normalShader.glsl
// module id = 21
// module chunks = 0